/**
 * @generated SignedSource<<f579eb8f66fe4834cc653961c4e5ca14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
export type TodoCategoryEditScreenQuery$variables = {
  id: string;
};
export type TodoCategoryEditScreenQuery$data = {
  readonly store: {
    readonly defaultTodoCategory: {
      readonly id: string;
    } | null;
  };
  readonly todoCategory: {
    readonly icon: TodoCategoryIcon | null;
    readonly id: string;
    readonly isDefault: boolean;
    readonly tags: ReadonlyArray<{
      readonly color: string;
      readonly id: string;
      readonly title: string;
    }>;
    readonly title: string;
    readonly totalCount: number;
  };
};
export type TodoCategoryEditScreenQuery = {
  response: TodoCategoryEditScreenQuery$data;
  variables: TodoCategoryEditScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "TodoCategory",
  "kind": "LinkedField",
  "name": "defaultTodoCategory",
  "plural": false,
  "selections": [
    (v1/*: any*/)
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ],
  "concreteType": "TodoCategory",
  "kind": "LinkedField",
  "name": "todoCategory",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDefault",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategoryTag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoCategoryEditScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v4/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoCategoryEditScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v4/*: any*/)
    ]
  },
  "params": {
    "cacheID": "97a4069ad06de1200593c63036bf4b96",
    "id": null,
    "metadata": {},
    "name": "TodoCategoryEditScreenQuery",
    "operationKind": "query",
    "text": "query TodoCategoryEditScreenQuery(\n  $id: ID!\n) {\n  store {\n    defaultTodoCategory {\n      id\n    }\n    id\n  }\n  todoCategory(id: $id) {\n    id\n    title\n    icon\n    totalCount\n    isDefault\n    tags {\n      id\n      title\n      color\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "278fef8c4f603a93ff56a028185ee864";

export default node;
